/* unplugin-vue-components disabled */import { render } from "./process.vue?vue&type=template&id=55e460da&scoped=true"
const script = {}

import "./process.vue?vue&type=style&index=0&id=55e460da&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e460da"]])

export default __exports__